import { lazy, Suspense, useEffect } from 'react'
import { Flex, VStack } from '@chakra-ui/react'
import RouteContentFallback from '../../../components/common/RouteContentFallback'
import Workspace from '../../../components/Planning/Workspace'

const loadAttendanceCalendarContent = () => import('./AttendanceCalendarContent')
const loadAttendanceSummaryFull = () => import('./AttendanceSummaryFull')
const loadLeaveManagementPanel = () => import('./LeaveManagementPanel')
const loadPlanningTimelinePanel = () => import('./PlanningTimelinePanel')
const loadPastRequestsPage = () => import('../Calender/PastRequestsPage')
const loadTimeTrackingWrapper = () => import('../../../components/TimeTracking/TimeTrackingWrapper')

const AttendanceCalendarContent = lazy(loadAttendanceCalendarContent)
const AttendanceSummaryFull = lazy(loadAttendanceSummaryFull)
const LeaveManagementPanel = lazy(loadLeaveManagementPanel)
const PlanningTimelinePanel = lazy(loadPlanningTimelinePanel)
const PastRequestsPage = lazy(loadPastRequestsPage)
const TimeTrackingWrapper = lazy(loadTimeTrackingWrapper)

function PlanningPage({ selectedTab }: { selectedTab?: string }) {
  const tab = selectedTab || 'attendance-calendar'

  useEffect(() => {
    void loadAttendanceCalendarContent()
    void loadPastRequestsPage()
    void loadAttendanceSummaryFull()
    void loadLeaveManagementPanel()
    void loadPlanningTimelinePanel()
    void loadTimeTrackingWrapper()
  }, [])

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%">
        <Suspense fallback={<RouteContentFallback />}>
          {tab === 'attendance-calendar' && <AttendanceCalendarContent />}
          {tab === 'past-requests' && <PastRequestsPage />}
          {tab === 'attendance' && <AttendanceSummaryFull />}
          {tab === 'workspace' && <Workspace />}
          {tab === 'offices' && <Workspace initialSubTab="offices" />}
          {tab === 'leave-management' && <LeaveManagementPanel />}
          {tab === 'timeline' && <PlanningTimelinePanel />}
          {tab === 'time-tracking' && <TimeTrackingWrapper />}
        </Suspense>
      </VStack>
    </Flex>
  )
}

export default PlanningPage
